//@ts-nocheck

'use client'

import React, { memo } from 'react'

import SectionThemeProvider from '../../../contexts/SectionTheme.context'

import * as Components from '../'
import * as Models from '../../../models'

import * as S from './SectionBuilder.styles'

interface SectionData {
  type: string;
  sectionId?: string;
  colorScheme?: string;
  news?: any[];
  title?: {
    id: number;
    as: string;
    typo: string;
    content: string;
  }
  preTitle?: {
    id: number;
    as: string;
    typo: string;
    content: string;
  }
  // Add additional prop types for each component's props if needed
}

interface SectionBuilderProps {
  data?: SectionData[];
  pageId?: number;
}

const componentsDispatcher = {
  // CMS: Organism
  BannerImage: 'Banner',
  BentoBox: 'BentoBox',
  FaqSpecified: 'Faq',
  FaqSimple: 'Faq',
  InteractiveTabsBanner: 'Tabs',
  FeatureListStatistic: 'FeatureLists',
  Iframe: 'Iframe',
  TextImage: 'TextImage',
  TextRichText: 'Text',
  TextHeadingLight: 'Text',
  TextHeadingBig: 'Text',
  TextColumns: 'Text',
  TextQuote: 'Text',
  TextWithImage: 'Text',
  HeroPrimary: 'HeroPrimary',
  HeroSecondary: 'HeroSecondary',
  HeroTertiary: 'HeroTertiary',
  HeroQuaternary: 'HeroQuaternary',
  HeroNews: 'HeroNews',
  CardExpertise: 'CarouselCards',
  CardSquare: 'CarouselCards',
  CardNews: 'CarouselCards',
  CardDocuments: 'CarouselCards',
  CardCase: 'CarouselCards',
  CardCertification: 'CarouselCards',
  calendar: 'Calendar',
  TimelineCarousel: 'BannerCarousel',
  TestimonialsImage: 'Testimonial',
  TestimonialsQuote: 'Testimonial',
  storeLocator: 'StoreLocator',
  ImageComparison: 'ImageComparison',
  BentoBoxCase: 'BentoBoxCase',
  FeatureBannerWithList: 'FeatureBannerWithList',
  StickyCta: 'StickyCta',
  ResourceHub: 'ResourceHub',
  ComposableForm: 'ComposableForm'
}

const SectionBuilder = memo(({ data = [], pageId }: SectionBuilderProps) => (
  <>
    {data.map((props, index) => {
    const Component = Components[componentsDispatcher[props.type]]
    const formattedData = Component ? Models[componentsDispatcher[props.type]](props) : null
    const key = `section-${props.type}-${index + 1}`
    const withBackground = props.withBackground
    const ignoreHorizontalPadding = props.type === 'HeroPrimary' || 
                                    props.type === 'HeroSecondary' || 
                                    props.type === 'HeroTertiary' || 
                                    props.type === 'HeroQuaternary' ||
                                    props.type === 'HeroNews'

    return Component ? (
      <SectionThemeProvider
        key={key}
        colorScheme={formattedData ? formattedData.colorScheme : 'green'}
      >
        <S.Section
          withBackground={withBackground}
          colorScheme={formattedData ? formattedData.colorScheme : 'green'}
          ignoreHorizontalPadding={ignoreHorizontalPadding}
          className={withBackground ? 'with-background' : 'without-background'}
          id={props.sectionId}
        >
          <Component 
            {...formattedData}
            withBackground={withBackground}
            {...(props.type === 'ComposableForm' && pageId ? { pageId } : {})}
          />
        </S.Section>
      </SectionThemeProvider>
    ) : (
      <div key={key}>Component not found for type: {props.type}</div>
    )
    })}
  </>
))


export default SectionBuilder
